/* eslint-disable react/prop-types */
import ContentLoader from "react-content-loader";
import { Card, CardBody, Col, Row } from 'reactstrap';

const ClientCardLoader = () => {
  const agencyInfo = JSON.parse(localStorage.getItem("agencyInfo") || "{}");
  const layoutTheme = agencyInfo.data?.layout_theme || "light";

  return (
    <Col xs={12} sm={6} md={4} lg={3}>
      <Card className="mb-3">
        <CardBody>
          <div className="d-flex justify-content-between align-items-center">
            <div style={{ flex: 1 }}>
              {/* Client Name */}
              <ContentLoader
                speed={2}
                width={200}
                height={25}
                viewBox="0 0 200 25"
                backgroundColor={layoutTheme === "light" ? "#f3f3f3" : "var(--bs-header-bg)"}
                foregroundColor={layoutTheme === "light" ? "#ecebeb" : "var(--bs-white)"}
                style={{ marginBottom: '15px' }}
              >
                <rect x="0" y="5" rx="4" ry="4" width="160" height="15" />
              </ContentLoader>
              
              {/* Members and Orders */}
              <ContentLoader
                speed={2}
                width={180}
                height={20}
                viewBox="0 0 180 20"
                backgroundColor={layoutTheme === "light" ? "#f3f3f3" : "var(--bs-header-bg)"}
                foregroundColor={layoutTheme === "light" ? "#ecebeb" : "var(--bs-white)"}
              >
                <rect x="0" y="2" rx="3" ry="3" width="70" height="12" />
                <rect x="85" y="2" rx="3" ry="3" width="65" height="12" />
              </ContentLoader>
            </div>
            
            {/* Delete Icon */}
            <ContentLoader
              speed={2}
              width={24}
              height={24}
              viewBox="0 0 24 24"
              backgroundColor={layoutTheme === "light" ? "#f3f3f3" : "var(--bs-header-bg)"}
              foregroundColor={layoutTheme === "light" ? "#ecebeb" : "var(--bs-white)"}
            >
              <circle cx="12" cy="12" r="10" />
            </ContentLoader>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

const CustomClientCardLoader = ({ count = 12 }) => {
  return (
    <Row>
      {Array.from({ length: count }, (_, index) => (
        <ClientCardLoader key={index} />
      ))}
    </Row>
  );
};

export default CustomClientCardLoader;